import type { ReviewListResponseReviewsItemReviewerBasicInfo } from './reviewListResponseReviewsItemReviewerBasicInfo';
import type { ReviewListResponseReviewsItemReviewerSocial } from './reviewListResponseReviewsItemReviewerSocial';

/**
 * 리뷰 작성자 요약 정보
 */
export type ReviewListResponseReviewsItemReviewer = {
  /** 사용자 기본 정보 */
  basicInfo: ReviewListResponseReviewsItemReviewerBasicInfo;
  /** 소셜 관계 정보 */
  social?: ReviewListResponseReviewsItemReviewerSocial;
};
